import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
// import { DebugPlugin } from '@microsoft/applicationinsights-debugplugin-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { appInsightsConnectStr } from './constants/config';

const reactPlugin = new ReactPlugin();
// const toTrack = [
//   'trackEvent',
//   'trackPageView',
//   'trackPageViewPerformance',
//   'trackException',
//   'trackTrace',
//   'trackMetric',
//   'trackDependencyData',
//   'throwInternal', // called when a message is logged internally
//   'logInternalMessage', // called when a message is logged internally
//   'triggerSend', // called when data is queued to be sent to the server
//   '_sender', // called when data is sent to the server
// ];
// const debugPluginInstance = new DebugPlugin();

// Click analytics config

const clickPluginInstance = new ClickAnalyticsPlugin();
// Click Analytics configuration
const clickPluginConfig = {
  autoCapture: true,
  dataTags: {
    useDefaultContentNameOrId: true,
  },
};

const appInsights = new ApplicationInsights({
  config: {
    connectionString: appInsightsConnectStr,
    correlationHeaderExcludedDomains: [
      'onemap-ms.bpglobal.com',
      'onemap-eaa.bpglobal.com',
      'services.arcgisonline.com',
      'server.arcgisonline.com',
      'js.arcgis.com',
      'static.arcgis.com',
    ],
    extensions: [reactPlugin, clickPluginInstance],
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    extensionConfig: {
      // [DebugPlugin.identifier]: {
      //   trackers: toTrack,
      // },
      [clickPluginInstance.identifier]: clickPluginConfig,
    },
  },
});
appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
  env.tags = env.tags || {};
  env.tags['ai.cloud.role'] = 'BP GTA Downmanning';
});

export { reactPlugin, appInsights };
